import { Divider, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
    Control,
    FieldErrors,
    UseFormRegister,
    UseFormReset,
    UseFormSetValue,
} from "react-hook-form";
import { shallowEqual, useSelector } from "react-redux";
import { callAPI, dateFormat, IsSmallScreen, Method } from "../../../../commonFunctions/CommonFunctions";
import WSButton from "../../../../Components/Button/WSButton";
import WSDateTimeField from "../../../../Components/DateField/WSDateTimePicker";
import WSHiddenField from "../../../../Components/HiddenField/WSHiddenField";
import WSSelectField from "../../../../Components/Select/WSSelect";
import WSTextField from "../../../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../../../Components/WSTextArea/WSTextArea";
import clientConfig from '../../../../Config/clientConfig.json';
import { AppState } from "../../../../StateManagement/types";
interface CallProps {
    control?: Control<any>;
    errors?: FieldErrors;
    register: UseFormRegister<any>;
    id: any;
    reset: UseFormReset<any>;
    callId?: string;
    setValue: UseFormSetValue<any>;
    onCancel: () => void
}



const CallDrawyer: React.FC<CallProps> = ({
    control, id, register, callId, reset, setValue, onCancel
}) => {
    const isMobile = IsSmallScreen();

    useEffect(() => {
        return () => {
            reset();
        };
    }, []);
    useEffect(() => {
        const getCalls = async () => {
            try {
                const response: any = await callAPI(`call-logs`, Method.GET, null, callId);
                if (response?.data) {
                    setValue('callType', response?.data?.callType)
                    setValue('callStart', dateFormat(response?.data?.callStart, 'DD-MM-YYYY HH:mm:ss'))
                    setValue('callDuration', response?.data?.callDuration)
                    setValue('subject', response?.data?.subject)
                    setValue('callPurpose', response?.data?.callPurpose)
                    setValue('callResult', response?.data?.callResult)
                    setValue('callStatus', response?.data?.callStatus)
                    setValue('description', response?.data?.description)
                }
            }
            catch (e) {
            }
        }
        if (callId) {
            getCalls();
        }
    }, [callId])
    const reduxComponentData = useSelector(
        (state: AppState) => state.components["callSubmit"],
        shallowEqual
    );

    // Local state to store Redux data
    const [componentData, setComponentData] = useState(reduxComponentData);

    // Update useState when Redux state changes
    useEffect(() => {
        if (reduxComponentData) {
            setComponentData(reduxComponentData);
        }
    }, [reduxComponentData]);
    return (
        <Grid >
            {
                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12}>
                        <Typography fontWeight={"bold"} sx={{ fontSize: '.9rem' }}>Call Information</Typography>
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <WSTextField
                            rules={{ required: true }}
                            {...register("subject")}
                            id="subject"
                            control={control}
                            label="Subject"
                            name="subject"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            label={"Call Type"}
                            {...register("callType")}
                            id="callType"
                            name="callType"
                            isMobile={isMobile}
                            options={clientConfig.callTypeSourceConfig.staticOptionData}
                            control={control}
                            rules={{ required: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            label={"Call Status"}
                            {...register("callStatus")}
                            id="callStatus"
                            isMobile={isMobile}
                            name="callStatus"
                            options={clientConfig.callStatusSourceConfig.staticOptionData}
                            control={control}
                            rules={{ required: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <WSDateTimeField
                            label={"Call Start"}
                            id="callStart"
                            setValue={setValue}
                            name="callStart"
                            control={control}
                            viewClock={false}
                            rules={{ required: true }}

                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <WSTextField
                            rules={{ required: true }}
                            {...register("callDuration")}
                            id="callDuration"
                            control={control}
                            label="Call Duration"
                            name="callDuration"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSTextField
                            rules={{ required: true }}
                            {...register("callPurpose")}
                            id="callPurpose"
                            control={control}
                            label="Call Purpose"
                            name="callPurpose"
                        />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <WSTextField
                            rules={{ required: true }}
                            {...register("callResult")}
                            id="callResult"
                            control={control}
                            label="Call Result"
                            name="callResult"
                        />
                    </Grid>



                    <Grid item xs={12} sm={12}>
                        <WSTextAreaField
                            label={"description"}
                            {...register("description")}
                            id="description"
                            name="description"
                            control={control}
                            rules={{ required: true }}
                            rows={2}
                        />
                    </Grid>
                    <WSHiddenField control={control} name="callId" defaultValue={callId} />
                    <Grid item xs={12} sm={12}>
                        <Divider />
                    </Grid>
                    <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                        <Grid item sx={{ marginRight: 0 }}>
                            <WSButton className="ws-theme-crm" variant="outlined" id='callSubmit' label={"Save"} type="submit" size="medium" loading={reduxComponentData?.data?.loading} />
                        </Grid>
                        <Grid item sx={{ marginRight: 0 }}>
                            <WSButton id='cancel' label={"Cancel"} onClick={onCancel} type="button" size="medium" variant="outlined" className="ws-theme-crm" />
                        </Grid>
                    </Grid>
                </Grid >
            }
        </Grid >
    );
};
export default CallDrawyer;
